import { render, staticRenderFns } from "./GrupoPermissao.vue?vue&type=template&id=a81f9128&scoped=true"
import script from "./GrupoPermissao.vue?vue&type=script&lang=js"
export * from "./GrupoPermissao.vue?vue&type=script&lang=js"
import style0 from "./GrupoPermissao.vue?vue&type=style&index=0&id=a81f9128&prod&scoped=true&lang=css"
import style1 from "./GrupoPermissao.vue?vue&type=style&index=1&id=a81f9128&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81f9128",
  null
  
)

export default component.exports